namespace Matrix.Administration {

    @Serenity.Decorators.registerClass()
    export class RolePermissionDialog extends Serenity.TemplatedDialog<RolePermissionDialogOptions> {

        private permissions: PermissionCheckEditor;

        constructor(opt: RolePermissionDialogOptions) {
            super(opt);

            this.permissions = new PermissionCheckEditor(this.byId('Permissions'), {
                showRevoke: false
            });

            RolePermissionService.List({
                RoleName: this.options.roleName
            },
                response => {
                    this.permissions.value = response.Entities;
                });
        }

        protected getDialogOptions(): JQueryUI.DialogOptions {
            let opt = super.getDialogOptions();

            opt.buttons = [
                {
                    text: Q.text('Dialogs.OkButton'),
                    click: () => {
                        RolePermissionService.Update({
                            RoleName: this.options.roleName,
                            Permissions: this.permissions.value
                        }, () => {
                            this.dialogClose();
                            window.setTimeout(() => Q.notifySuccess(Q.text('Site.RolePermissionDialog.SaveSuccess')), 0);
                        });
                    }
                }, {
                    text: Q.text('Dialogs.CancelButton'),
                    click: () => this.dialogClose()
                }];

            opt.title = Q.format(Q.text('Site.RolePermissionDialog.DialogTitle'),
                this.options.title);

            return opt;
        }

        protected getTemplate(): string {
            return '<div id="~_Permissions"></div>';
        }
    }

    export interface RolePermissionDialogOptions {
        roleName?: string;
        title?: string;
    }
}